module.exports = __webpack_public_path__ + "img/img3.73465657.png";